import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BranchContainerModel, BranchDistanceContainerModel } from '../../../../../../models/aggregates/branch';
import { Core2Config } from '../../shared/core2Config';
import { ApiResponseModel, BasicApiResponseModel, PagingResponseModel } from '../../shared/api-response.model';
import { ApiVisa } from '../../shared/api-visa.model';
import { BranchCriteriaModelQuery } from '../../../criteria';
import { BaseApiPublicLoginTemplateService } from '../../shared/base-api-public-login-template.service';
import { Pagination } from '../../shared/pagination.model';


class BranchHdrQueryCriteriaClass {
}

@Injectable({
  providedIn: 'root'
})
export class BranchService extends BaseApiPublicLoginTemplateService<BranchContainerModel, BranchContainerModel, BranchContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'branches';
  readonly img_endpoint = Core2Config.TENANT_URL_PREFIX + Core2Config.DOMAIN_PREFIX + Core2Config.ERP_PREFIX + 'branches';
  static readonly BRANCH_SUBPATH = 'branches/';
  
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'branches';
    this.endpoint_path = Core2Config.DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'branches';
    this.endpoint_path_public_url = Core2Config.DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + BranchService.BRANCH_SUBPATH + BaseApiPublicLoginTemplateService.PUBLIC_EP;
    this.endpoint_path_login_url = Core2Config.DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + BranchService.BRANCH_SUBPATH + BaseApiPublicLoginTemplateService.LOGIN_ENTITY_EP;

    this.httpClient = http;
  }

  public getBranchDistancesFromUserPublic(
    oriLat: number,
    oriLong: number,
    visa: ApiVisa
  ): Observable<BasicApiResponseModel<BranchDistanceContainerModel>> {
    if (visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'branches/retrieve-branch-distances-from-origin/' + BaseApiPublicLoginTemplateService.PUBLIC_EP;
    }
    const UrlByCriteria = this.apiUrl + '?' +  `oriLat=${oriLat}&oriLong=${oriLong}`;
    return this.httpClient.get<BasicApiResponseModel<BranchDistanceContainerModel>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }

  getPromiseByCriteria(
    visa: ApiVisa, criteria?: BranchHdrQueryCriteriaClass
  ): Observable<ApiResponseModel<BranchContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const buildDocCriteria = new BranchCriteriaModelQuery(criteria);
    const UrlByCriteria = this.apiUrl + '/query?' + buildDocCriteria.query;
    return this.httpClient.get<ApiResponseModel<BranchContainerModel>>
      (UrlByCriteria, this.getHttpHeader(visa));
  }

  uploadBranchLogo(visa: ApiVisa, file: File, branchHdrGuid: string, imageType?: string) {
    // imageType = "BRANCH_IMAGE"
    if (this.img_endpoint && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.img_endpoint;
    }
    const formData: FormData = new FormData();
    if (file) {
      formData.append('files', file);
    }
    return this.httpClient.post(
      this.apiUrl + '/add-files/' + branchHdrGuid /*+ '?branchSystemType=' + imageType*/,
      formData,
      this.getHttpHeader(visa)
    );
  }

  updateBranchLogo(visa: ApiVisa, file: File, branchExtGuid: string) {
    if (this.img_endpoint && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.img_endpoint;
    }
    const formData: FormData = new FormData();
    if (file) {
      // formData.append('files', file);
      formData.append('file', file);
    }
    return this.httpClient.put(
      this.apiUrl + '/replace-file/' + branchExtGuid,
      formData,
      this.getHttpHeader(visa)
    );
  }

  getFile(branchExtGuid: string, visa: ApiVisa): Observable<Blob> {
    let url = this.apiUrl + '/file/' + branchExtGuid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.img_endpoint + '/file/' + branchExtGuid;
    }

    return this.httpClient.get<Blob>(url, this.getHttpHeaderBlob(visa));
  }

  deleteFile(branchExtGuid: string, visa: ApiVisa): Observable<Blob> {
    let url = this.apiUrl + '/file/' + branchExtGuid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.img_endpoint + '/file/' + branchExtGuid;
    }

    return this.httpClient.delete<Blob>(url, this.getHttpHeaderBlob(visa));
  }

  getAllBranchForAppletLoginEp(
    appletGuid: string,
    visa: ApiVisa
  ): Observable<BasicApiResponseModel<BranchContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.get<BasicApiResponseModel<BranchContainerModel>>(
      this.apiUrl + '/basic-info/applet-login-ep/' + appletGuid,
      this.getHttpHeader(visa)
    );
  }

  public getBranchByCriteriaForAppletLoginEp(
    appletGuid: string,
    pagination: Pagination,
    visa: ApiVisa,
    criteria?: any,
  ): Observable<PagingResponseModel<BranchContainerModel>> {
    // console.log('get by criteria bsae-api');
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const UrlByCriteria =
      this.apiUrl + '/basic-info/applet-login-ep/' + appletGuid + '/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<BranchContainerModel>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }

  public getBranchByGuidForAppletLoginEp(
    appletGuid: string,
    guid: string,
    visa: ApiVisa
  ): Observable<BasicApiResponseModel<BranchContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.get<BasicApiResponseModel<BranchContainerModel>>(
      this.apiUrl + '/basic-info/applet-login-ep/' + appletGuid + '/' + guid,
      this.getHttpHeader(visa)
    );
  }

  // will return multiple branches given multiple guids
  public getByMultipleGuidCriteria(
    branchGuids: string,
    visa: ApiVisa
  ): Observable<BasicApiResponseModel<BranchContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + "/backoffice-ep/query?hdr_guids="+branchGuids;
    }
    return this.httpClient.get<BasicApiResponseModel<BranchContainerModel>>(
      this.apiUrl,
      this.getHttpHeader(visa)
    );
  }

  public getByGuidWebsiteEp(
    websiteGuid: string,
    visa: ApiVisa
  ): Observable<ApiResponseModel<BranchContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + '/website-ep';
    }
    return this.httpClient.get<ApiResponseModel<BranchContainerModel>>(
      this.apiUrl + '/' + websiteGuid,
      this.getHttpHeader(visa)
    );
  }

  public getByGuidPublicEp(
    branchGuid: string,
    visa: ApiVisa
  ): Observable<BasicApiResponseModel<BranchContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + '/public';
    }
    return this.httpClient.get<BasicApiResponseModel<BranchContainerModel>>(
      this.apiUrl + '/' + branchGuid,
      this.getHttpHeader(visa)
    );
  }

  getBranchByHdrGuids(guid: any, visa: ApiVisa): Observable<BasicApiResponseModel<any>> {
    let url = visa.api_domain_url + this.endpoint_path + '/query?hdr_guids=' + guid;
    return this.httpClient.get<BasicApiResponseModel<any>>(
      url, this.getHttpHeader(visa)
    );
  }
}
